import _ from 'lodash';
import { getRotateByDocID } from 'lib/pdfHelpers';
import Api from 'domain/api';
import ROUTES_PATH from 'domain/router/routesPathConfig';
import { generatePath } from 'react-router-dom';

export function getRotationAngle(d) {
  if (!d || d.protected) return 0;
  const LSrotationAngle = getRotateByDocID(d.documentID);
  // $FlowFixMe Update document adapter to completely immutable
  const lsRotation = _.get(LSrotationAngle, 0);
  return typeof lsRotation === 'number' ? lsRotation : _.get(d, 'viewinfo.rotations[0]', 0);
}

// eslint-disable-next-line max-len
export function getPreviewSrc(companyId, documentID, preview, unsafe, withTimestamp) {
  return Api.getDocumentThumbnailUrl({
    companyId,
    documentID,
    preview,
    unsafe,
    t: withTimestamp ? Date.now() : undefined,
  });
}

export function getDocumentUrl(companyId, documentId) {
  return generatePath(ROUTES_PATH.DOCUMENT.absolute, {
    companyId,
    documentId,
  });
}
